import { useNavigate, useSearchParams } from "react-router-dom";
import { useContextSite } from "../../../context/Context";
import { useCallback, useEffect, useState } from "react";
import { Perfil } from "../../../services/Perfil";
import { toast } from "react-toastify";
import {
  IPerfilAtualizarForm,
  IPerfilAtualizarFormRHF,
} from "../../../types/perfil";
import { useForm, Controller, useFieldArray } from "react-hook-form";

export const useProfilesDetail = () => {
  const { setIsLoad } = useContextSite();
  const [params] = useSearchParams();
  const id = params.get("id");
  const navigate = useNavigate();
  const [recursos, setRecursos] = useState([] as string[]);

  const { handleSubmit, setValue, register, control } =
    useForm<IPerfilAtualizarFormRHF>({
      defaultValues: {
        ativo: false,
        nome: "",
        nomeRecursos: [],
        uuid: id,
      },
    });

  const { append, remove, fields } = useFieldArray({
    control,
    name: "nomeRecursos",
  });

  const getPerfil = useCallback(() => {
    setIsLoad(true);
    Perfil.getById({ id })
      .then(({ data }) => {
        setValue("ativo", data?.ativo);
        setValue("nome", data?.nome);
        const rec = data?.recursos?.map((r) => ({ value: r?.nome }));
        setValue("nomeRecursos", rec);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => {
        setIsLoad(false);
      });
  }, []);

  useEffect(() => {
    if (id) {
      getPerfil();
    }

    getRecursos();
  }, [id]);

  function handleSubmitForm(data: IPerfilAtualizarFormRHF) {
    setIsLoad(true);

    const PAYLOAD: IPerfilAtualizarForm = {
      ...data,
      nomeRecursos: data.nomeRecursos.map((r) => r.value),
    };

    Perfil.put(PAYLOAD)
      .then(() => {
        toast.success("Perfil atualizado com sucesso!");
        navigate("/configuracoes/perfis");
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  function handleChangeItem(value: string) {
    const hasItem = fields.findIndex((i) => i.value === value);
    if (hasItem >= 0) {
      remove(hasItem);
      return;
    }
    append({ value });
  }

  const getRecursos = useCallback(() => {
    Perfil.getRecursos()
      .then(({ data }) => {
        setRecursos(data);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      );
  }, []);

  return {
    handleSubmit,
    register,
    handleSubmitForm,
    Controller,
    control,
    recursos,
    fields,
    handleChangeItem,
  };
};
